export enum EquipmentSize {
    Large,
    Medium,
    Small,
    List,
    Mini,
    Create
}
